module.exports = __webpack_public_path__ + "static/LogoTextRightNameOnly-d7ae03c9e9b17f250bf1e0c09b0fbc51.svg";